"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Label = exports.TextArea = exports.Input = exports.TextInputWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var TextInputWrapper = _styled.default.div(function () {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  };
});

exports.TextInputWrapper = TextInputWrapper;

var Input = _styled.default.input(function (_ref) {
  var _ref$theme = _ref.theme,
      fonts = _ref$theme.fonts,
      space = _ref$theme.space;
  return {
    height: space.xxlarge,
    paddingLeft: space.base,
    borderRadius: space.xsmall,
    border: '1px solid lightgray',
    fontFamily: fonts.body,
    fontSize: 'inherit',
    transition: 'all 0.3s ease-in-out',
    '&:focus': {
      border: '1px solid black',
      outline: 'none'
    }
  };
});

exports.Input = Input;

var TextArea = _styled.default.textarea(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      fonts = _ref2$theme.fonts,
      space = _ref2$theme.space;
  return {
    padding: space.base,
    borderRadius: space.xsmall,
    border: '1px solid lightgray',
    fontFamily: fonts.body,
    '&:focus': {
      border: '1px solid black',
      outline: 'none'
    }
  };
});

exports.TextArea = TextArea;

var Label = _styled.default.label(function (_ref3) {
  var space = _ref3.theme.space;
  return {
    marginBottom: space.xsmall
  };
});

exports.Label = Label;